import angular from 'angular';

class GridController {
    constructor(){
        this.onEdit = this.onEdit || angular.noop;
        this.onDblClick = this.onDblClick || angular.noop;
        this.onDelete = this.onDelete || angular.noop;
    }

    edit(item){
        this.onEdit({item: item});
    }

    dblClick(item){
        console.log(item);
        this.onDblClick({item: item});
    }

    delete(item){
        this.onDelete({item: item});
    }
}


export {GridController};



// WEBPACK FOOTER //
// ./app/components/nalaz/grid/grid.controller.js